





























import {Component, Prop, Vue, Watch} from 'vue-property-decorator';

@Component
export default class CommonInput extends Vue {
  @Prop()
  private value!: string|number;

  @Prop()
  private label?: string;

  @Prop()
  private name?: string;

  @Prop({default: ''})
  private appendIcon!: string;

  @Prop({default: 'text'})
  private type!: string;

  @Prop()
  private rules?: Array<any>;

  @Prop({default: ''})
  private errorMessage!: string;

  @Prop({default: false})
  private disabled!: boolean;

  @Prop({default: ''})
  private hint!: string;

  @Prop({default: false})
  private persistentHint!: boolean;

  @Prop({default: false})
  private counter!: boolean;

  @Prop({default: false})
  private dark!: boolean;

  @Prop({default: ''})
  private prefix?: string;

  @Prop({default: false})
  private readonly?: boolean;

  @Prop({default: true})
  private rounded?: boolean;

  @Prop({default: false})
  private dense?: boolean;

  @Prop()
  private color?: string;

  @Prop({default: false})
  private loading?: boolean;

  @Watch('value')
  watchPropValue() {
    this.inputData = this.value;
  }

  private inputData: string|number = '';
  private changeTimeout: any = undefined;

  private handleOnChange() {
    this.clearKeyUpTimeout();
    this.$emit('input', this.inputData);
    this.$emit('change', this.inputData);
  }

  private clearKeyUpTimeout() {
    if (this.changeTimeout) {
      clearTimeout(this.changeTimeout);
      this.changeTimeout = undefined
    }
  }

  private handleKeyUp() {
    this.clearKeyUpTimeout();
    this.changeTimeout = setTimeout(() => {
      this.handleOnChange()
    }, 350)
  }

  private handleClickAppendIcon() {
    this.$emit('append-icon:click');
  }
}
